import React, { useCallback } from 'react';

import { Stack, Inline, Text } from '@atlaskit/primitives';
import Button from '@atlaskit/button/new';

import { BulkCreateNavigationHeader } from './BulkCreateNavigationHeader';
import {
	useAiBulkNavigationCurrentPage,
	useAiBulkNavigationGotoPage,
} from './AiBulkNavigationContextProvider';
import { SidePanel } from '@confluence/side-panel';

// This is the view for both AI and non-AI bulk create where users can edit and create individual issues
// Look into if using the Form component just complicates things or if it's necessary - https://atlassian.design/components/form/examples#select
export const BulkConfigureView = () => {
	const goToPage = useAiBulkNavigationGotoPage();
	const currentPage = useAiBulkNavigationCurrentPage();

	const onClose = useCallback(() => void goToPage('default'), [goToPage]);
	const isOpen = currentPage === 'configure';

	return (
		<SidePanel isOpen={isOpen}>
			<Stack>
				<BulkCreateNavigationHeader onClose={onClose} />
				<Text>Changing these settings might re-generate the issues list</Text>
				<Stack>
					<Text>Site</Text>
					<Text>Project</Text>
					<Text>Issue Type</Text>
				</Stack>
				<Inline>
					<Button>Cancel</Button>
					<Button appearance="primary">Save</Button>
				</Inline>
			</Stack>
		</SidePanel>
	);
};
